import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';
import { Trans } from 'react-i18next';

import { localStorageKeys } from '../../../../shared/config';
import { getEnvironment, useLocalStorage } from '../../../../shared/lib';

const environment = getEnvironment();

export const Modal = () => {
  const [accepted, setAccepted] = useLocalStorage(localStorageKeys.accessingPolicy, false);

  const showModal = !accepted && (environment === 'international' || environment === 'development');

  const handleAccept = () => {
    setAccepted(true);
  };

  return (
    <Dialog open={showModal} aria-describedby='accessing-policy-description'>
      <DialogTitle>
        <Trans i18nKey='accessing-policy-title' />
      </DialogTitle>
      <DialogContent>
        <DialogContentText id='accessing-policy-description'>
          <Trans
            i18nKey='accessing-policy-text'
            components={[<Typography component='a' color='GrayText' />, <Typography component='a' color='GrayText' />]}
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleAccept} autoFocus>
          <Trans i18nKey='accept' />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
